import { render, staticRenderFns } from "./DeletePromptModal.vue?vue&type=template&id=5eb43bbc"
import script from "./DeletePromptModal.vue?vue&type=script&lang=js"
export * from "./DeletePromptModal.vue?vue&type=script&lang=js"
import style0 from "./DeletePromptModal.vue?vue&type=style&index=0&id=5eb43bbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports